(() => {
    if (customElements.get("product-media")) {
        return;
    }

    class ProductMedia extends HTMLElement {
        constructor() {
            super();

            this.mainSliderElement = this.querySelector("[data-main-product-slider]");
            this.mainSliderDrag = Number(this.mainSliderElement.dataset.slidesCount) !== 1;
            // this.autoHeight = this.hasAttribute('data-autoheight');
            this.mainSlider = {
                element: this.mainSliderElement,
                instance: null,
                options: {
                    pagination: false,
                    waitForTransition: false,
                    flickMaxPages: 0.5,
                    arrows: false,
                    drag: this.mainSliderDrag,
                    type: "loop",
                },
            };
            this.thumbsSlider = {
                element: this.querySelector("[data-main-product-thumbs]"),
                nextArrow: this.querySelector("[data-thumbs-next]"),
                instance: null,
                options: {
                    pagination: false,
                    waitForTransition: false,
                    flickMaxPages: 0.5,
                    arrows: false,
                    isNavigation: true,
                    perPage: 3,
                    gap: "10px",
                    type: Number(this.mainSliderElement.dataset.slidesCount) > 2 ? "loop" : "slide",
                    breakpoints: {
                        749: {
                            gap: "6px",
                        },
                    },
                },
            };
            this.controls = this.querySelectorAll("[data-control]");

            this.controls.forEach((control) => {
                control.addEventListener("click", this.onControlClick.bind(this));
            });

            if (this.thumbsSlider.nextArrow) {
                this.thumbsSlider.nextArrow.addEventListener("click", (event) => {
                    this.onControlClick(event, this.thumbsSlider.instance);
                });
            }

            window.addEventListener("DOMContentLoaded", this.initSlider.bind(this));
            window.addEventListener("resize", debounce(this.initSlider.bind(this), 500));
        }

        connectedCallback() {
            this.initSlider();

            document.body.addEventListener(
                "touchstart",
                () => {
                    this.querySelectorAll("deferred-media[data-autoplay]").forEach((media) => {
                        const iframe = media.querySelector("iframe");

                        if (!iframe) return;

                        if (iframe.classList.contains("js-youtube")) {
                            iframe.contentWindow.postMessage('{"event":"command","func":"' + "playVideo" + '","args":""}', "*");
                        }

                        if (iframe.classList.contains("js-vimeo")) {
                            iframe.contentWindow.postMessage('{"method":"play"}', "*");
                        }
                    });
                },
                { once: true }
            );
        }

        onControlClick(event, sliderInstance = this.mainSlider.instance) {
            event.preventDefault();

            if (!sliderInstance) {
                return;
            }

            const action = event.target.hasAttribute("data-prev") ? "<" : ">";

            sliderInstance.go(action);
        }

        initSlider() {
            if (window.innerWidth >= 990 && !this.mainSlider.element.hasAttribute("data-main-slider-desktop")) {
                this.mainSlider.element.classList.add("is-initialized");

                if (this.mainSlider.instance) {
                    this.mainSlider.instance.destroy(true);
                    this.mainSlider.instance = null;
                }

                return;
            }

            if (this.mainSlider.instance) {
                return;
            }

            if (this.thumbsSlider.element) {
                this.thumbsSlider.instance = new Splide(this.thumbsSlider.element, this.thumbsSlider.options).mount();
            }

            this.mainSlider.instance = new Splide(this.mainSlider.element, this.mainSlider.options);

            // this.mainSlider.instance.on("active", (e) => {
            //     if (!e.isClone) {
            //         let idMedia = Number(e.slide.dataset.mediaId);
            //         let selectorElement = document.querySelector("product-selector");
            //         let variantData = [];
            //         try {
            //             variantData = selectorElement.getVariantData();
            //         } catch (error) {
            //             return;
            //         }
            //         let variantOfMedia = variantData.find((v) => v.featured_media && v.featured_media.id == idMedia);
            //         let fakeInput = null;
            //         document.querySelectorAll(".js.main-product__form-input").forEach((elm) => {
            //             let postionOption = Number(elm.dataset.optionIndex);
            //             let inputNewChecked = elm.querySelector(`input[type="radio"][value="${variantOfMedia["option" + postionOption]}"]`);
            //             elm.querySelectorAll('input[type="radio"]').forEach((ip) => (ip.checked = false));
            //             inputNewChecked.checked = true;
            //             fakeInput = inputNewChecked;
            //         });
            //         if (variantData && fakeInput) selectorElement.onOptionChange({ target: fakeInput });
            //     }
            // });

            // if (this.mainSlider.bar) {
            //     this.mainSlider.instance.on("mounted move", () => {
            //         const sliderEnd = this.mainSlider.instance.Components.Controller.getEnd() + 1;
            //         this.mainSlider.bar.style.width = `${(100 * (this.mainSlider.instance.index + 1)) / sliderEnd}%`;
            //     });
            // }

            this.thumbsSlider.instance ? this.mainSlider.instance.sync(this.thumbsSlider.instance).mount() : this.mainSlider.instance.mount();
        }

        goToSlide(mediaId) {
            if (!this.mainSlider.instance) {
                const media = this.mainSlider.element.querySelector(`[data-media-id="${mediaId}"]`);

                if (!media) {
                    return;
                }

                media.scrollIntoView({
                    behavior: "smooth",
                });

                return;
            }

            const slideIndex = this.mainSlider.instance.Components.Elements.slides.findIndex((slide) => Number(slide.dataset.mediaId) === mediaId);

            this.mainSlider.instance.go(slideIndex);
        }
    }

    customElements.define("product-media", ProductMedia);
})();
